<template>
  <div class="addPackageWrapper">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomSelect
          :options="residencyOptions"
          label="ЖК"
          optionValueKey="resident_id"
          optionLabelKey="resident_name"
          :required="true"
          placeholder="Выберите ЖК"
          :value="formData.resident_id || ''"
          @change="(value, row) => onChange('resident_id', value, row)"
          style="width: 100%;"
        />
      </div>
      <div class="form__item">
        <CustomSelect
          :options="projectTypesOptions"
          label="Тип проекта"
          optionValueKey="project_type_id"
          optionLabelKey="project_type_name"
          :required="true"
          placeholder="Выберите тип проекта"
          :value="formData.project_type_id || ''"
          @change="(value, row) => onChange('project_type_id', value, row)"
          style="width: 100%;"
        />
      </div>
      <CustomModalFooter :btn-loading="loading" submit-btn-text="Создать" />
    </q-form>
  </div>
</template>

<script>
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { getProjectTypes } from "@/views/BuildingSettings/services";
import { getResidencyOptions } from "@/views/ProjectsEntry/services";

export default {
  name: "add-project-entry",
  components: { CustomSelect, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      residencyOptions: [],
      residencyLoading: false,
      projectTypesOptions: [],
      formData: {
        resident_id: "",
        project_type_id: "",
      },
      projectOptions: [],
      resOptions: [],
      projectLoading: false,
      projectSearchTimeout: null,
      entranceOptions: [],
      entranceData: [],
    };
  },
  async mounted() {
    this.isFetching = true;
    await this.getProjectTypes();
    await this.getResidencyOptions();
    this.isFetching = false;
  },
  methods: {
    async getProjectTypes() {
      const res = await getProjectTypes();
      this.projectTypesOptions = res || [];
    },
    async getResidencyOptions() {
      const res = await getResidencyOptions();
      this.residencyOptions = res || [];
    },
    async onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      if (!this.formData.resident_id || !this.formData.project_type_id) {
        return
      }

      this.loading = true;

      const filteredFormData = {
        resident_id: this.formData.resident_id,
        project_type_id: this.formData.project_type_id,
      };
      await this.data?.onSubmit(filteredFormData);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.addPackageWrapper {
  max-width: 700px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
}

.form {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
  margin-top: 15px;

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;
  }

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>
